import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabs = [
  { path: "/guests", labelKey: "reservationTabs.currentGuests" },
  { path: "/expected", labelKey: "reservationTabs.upcoming" },
  { path: "/archived", labelKey: "reservationTabs.archived" },
];

export default function ReservationsTabs({ activePath }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className="reservations-tabs"
      role="tablist"
      aria-label={t("nav.reservations")}
    >
      {tabs.map(({ path, labelKey }) => {
        const active = path === activePath;

        return (
          <button
            key={path}
            className={`reservations-tab${active ? " reservations-tab--active" : ""}`}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => navigate(path)}
          >
            {t(labelKey)}
          </button>
        );
      })}
    </div>
  );
}
